export default __webpack_public_path__ + "static/media/aws.e647029c.png";